export default () => {
    if (process.env.NODE_ENV === "production") {
        return process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY_LIVE as string
    }
    return process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY_TEST as string
}